<template>
  <div>
    <div class="ccui-app-iframe-container-detail">
      <div class="ccui-app-iframe-container-detail-body">
        <el-tabs value="1" class="el-tabs__customize">
          <el-tab-pane label="评审项目信息" name="1">
            <el-form
              :model="editScoreData"
              ref="editScoreDataForm"
              label-width="120px"
            >
              <el-row>
                <template v-if="subPackageFlag == '1'">
                  <el-col :span="12">
                    <template v-if="operateType !== 'add'">
                      <el-form-item prop="packName" label="包件名称：">
                        <el-input
                          disabled
                          v-model="editScoreData.packName"
                        ></el-input>
                      </el-form-item>
                    </template>
                    <template v-else>
                      <el-form-item
                        prop="packId"
                        label="包件名称："
                        :rules="{ required: true, message: '请选择包件名称' }"
                      >
                        <el-select
                          v-model="editScoreData.packId"
                          @change="changePack"
                        >
                          <el-option
                            v-for="item in packList"
                            :label="item.packName"
                            :value="item.packId"
                            :key="item.packId"
                          ></el-option>
                        </el-select>
                      </el-form-item>
                    </template>
                  </el-col>
                </template>
                <el-col :span="12">
                  <el-form-item
                    prop="scoreItem"
                    label="评审项目："
                    :rules="{ required: true, message: '请选择评审项目' }"
                  >
                    <!--                    <template v-if="scoreItemDisabled">-->
                    <!--                      <el-input-->
                    <!--                        disabled-->
                    <!--                        v-model="editScoreData.scoreItemStr"-->
                    <!--                      ></el-input>-->
                    <!--                    </template>-->
                    <!--                    <template v-else>-->
                    <el-select
                      v-model="editScoreData.scoreItem"
                      @change="changeScoreItem"
                      :disabled="scoreItemSelectDisabled"
                    >
                      <el-option
                        v-for="item in scoreProject"
                        :label="item.name"
                        :value="item.value"
                        :key="item.value"
                      ></el-option>
                    </el-select>
                    <!--                    </template>-->
                  </el-form-item>
                </el-col>
              </el-row>
              <el-row>
                <el-col :span="12">
                  <el-form-item
                    prop="sumForm"
                    label="汇总形式："
                    :rules="{ required: true, message: '请选择汇总形式' }"
                  >
                    <el-select v-model="editScoreData.sumForm">
                      <el-option value="101" label="平均值">平均值</el-option>
                    </el-select>
                  </el-form-item>
                </el-col>
                <el-col :span="12">
                  <el-form-item
                    prop="weight"
                    label="权重："
                    :rules="{ required: true, message: '请输入权重' }"
                  >
                    <el-input
                      class="input-short"
                      disabled
                      v-model="editScoreData.weight"
                      :min="0"
                    ></el-input>
                  </el-form-item>
                </el-col>
              </el-row>
            </el-form>
          </el-tab-pane>
        </el-tabs>
        <el-tabs value="1" class="el-tabs__customize">
          <el-tab-pane label="评分细则项目" name="1">
            <el-form
              :model="editScoreData"
              ref="editScoreDataForm2"
              label-width="140px"
            >
              <el-row>
                <el-col :span="13">
                  <template v-if="operateType === 'add'">
                    <el-form-item
                      prop="scoreTemplateId"
                      label="评分细则项目名称："
                      :rules="{
                        required: true,
                        message: '请选择评分项目细则名称'
                      }"
                    >
                      <el-select
                        v-model="editScoreData.scoreTemplateId"
                        @change="changeScoreTemplate"
                      >
                        <el-option
                          v-for="(item, index) in templateList"
                          :label="item.templateName"
                          :value="item.scoreTemplateId"
                          :key="index"
                        ></el-option>
                      </el-select>
                    </el-form-item>
                  </template>
                </el-col>
                <el-col :span="11">
                  <el-button type="single-number" plain @click="addRow"
                    >新增</el-button
                  >
                  <template v-if="operateType === 'add'">
                    <el-button type="single-number" plain @click="addTemplate"
                      >新增模板</el-button
                    >
                    <el-button type="single-number" plain @click="editTemplate"
                      >编辑模板</el-button
                    >
                    <el-button
                      type="single-number"
                      plain
                      @click="deleteTemplate"
                      >删除模板</el-button
                    >
                  </template>
                </el-col>
              </el-row>
              <el-table :data="editScoreData.tableData" border>
                <el-table-column label="评审细则" prop="scoreRule" width="120">
                  <template slot="header">
                    <span class="star">*</span>评审细则
                  </template>
                  <template slot-scope="{ row }">
                    <el-input
                      v-model="row.scoreRule"
                      maxlength="150"
                      show-word-limit
                      class="input-short word-limit input-width;"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="细则权重"
                  prop="scoreWeight"
                  width="120"
                >
                  <template slot="header">
                    <span class="star">*</span>细则权重
                  </template>
                  <template slot-scope="{ row, $index }">
                    <el-input
                      type="number"
                      @change="computeWeight($event, $index)"
                      v-model="row.scoreWeight"
                      :min="0"
                      :max="99999"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column
                  label="评审标准"
                  prop="scoreStandard"
                  width="120"
                >
                  <template slot="header">
                    <span class="star">*</span>评审标准
                  </template>
                  <template slot-scope="{ row }">
                    <el-input
                      v-model="row.scoreStandard"
                      maxlength="500"
                      show-word-limit
                      class="input-short word-limit input-width;"
                    ></el-input>
                  </template>
                </el-table-column>
                <el-table-column label="操作" width="120">
                  <template slot-scope="scope">
                    <el-button @click="deleteRow(scope.$index)" type="text"
                      >删除</el-button
                    >
                  </template>
                </el-table-column>
              </el-table>
            </el-form>
          </el-tab-pane>
        </el-tabs>
      </div>
    </div>
    <!-- 新增/修改模板 -->
    <el-dialog
      title="模板管理"
      :visible.sync="templateVisible"
      append-to-body
      width="800px"
      v-if="templateVisible"
    >
      <el-form :model="templateForm" ref="templateForm" label-width="120px">
        <el-row>
          <el-col :span="12">
            <el-form-item
              label="模板名称："
              prop="templateName"
              :rules="{ required: true, message: '模板名称不能为空' }"
            >
              <el-input
                maxlength="150"
                show-word-limit
                class="input-short word-limit input-width;"
                placeholder="请输入模板名称"
                v-model="templateForm.templateName"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模板编辑单位：" prop="orgFullName">
              <el-input
                disabled
                placeholder="请输入模板编辑单位"
                v-model="templateForm.orgFullName"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="模板编辑人：" prop="username">
              <el-input
                disabled
                placeholder="请输入模板编辑人"
                v-model="templateForm.username"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="模板编辑时间：" prop="createTime">
              <el-date-picker
                v-model="templateForm.createTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间"
              >
              </el-date-picker>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="模板说明：" prop="templateDesc">
              <el-input
                maxlength="500"
                show-word-limit
                class="input-short word-limit input-width;"
                placeholder="请输入模板说明"
                v-model="templateForm.templateDesc"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <div class="fr">
          <el-button type="primary" plain @click="addTemplateRow"
            >新增</el-button
          >
        </div>
        <el-table v-if="templateVisible" :data="templateTableData" border>
          <el-table-column label="评审细则" prop="scoreRule" width="120">
            <template slot="header">
              <span class="star">*</span>评审细则
            </template>
            <template slot-scope="{ row }">
              <el-input
                v-model="row.scoreRule"
                maxlength="150"
                show-word-limit
                class="input-short word-limit input-width;"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="细则权重" prop="scoreWeight" width="120">
            <template slot="header">
              <span class="star">*</span>细则权重
            </template>
            <template slot-scope="{ row }">
              <el-input v-model="row.scoreWeight" type="number"></el-input>
            </template>
          </el-table-column>
          <el-table-column label="评审标准" prop="scoreStandard" width="120">
            <template slot="header">
              <span class="star">*</span>评审标准
            </template>
            <template slot-scope="{ row }">
              <el-input
                v-model="row.scoreStandard"
                maxlength="500"
                show-word-limit
                class="input-short word-limit input-width;"
              ></el-input>
            </template>
          </el-table-column>
          <el-table-column label="操作" width="120">
            <template slot-scope="scope">
              <el-button @click="deleteTemplateRow(scope.$index)" type="text"
                >删除</el-button
              >
            </template>
          </el-table-column>
        </el-table>
      </el-form>
      <div slot="footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="templateVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="confirmEditTemplate"
          >确定</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  scpListPurchaseSchemePackageApi,
  scpQryScoreTemplateListApi,
  scpDealScoreTemplateOperateApi,
  scpDealScoreTemplateDeleteApi,
  scpQryScoreTemplateDetailApi,
  scpGetEmpInfoApi
} from "@/app/sourcingFlow/api/scp-expertEvaluation.js";
export default {
  name: "editScoreScaleDeveloped",
  props: {
    editScoreDataStr: {
      type: Object,
      default() {
        return {};
      }
    },
    operateType: {
      type: String,
      default: "" // add新增 edit编辑 copy复制
    },
    scoreItemDisabled: {
      type: Boolean,
      default: false // 评审项目是否禁用
    },
    scoredPack: {
      type: Array,
      default() {
        return []; // 已经评分的包件
      }
    }
  },
  data() {
    return {
      scoreProjectOrigin: [
        {
          value: "0",
          name: "技术"
        },
        {
          value: "1",
          name: "商务"
        },
        {
          value: "2",
          name: "技术加分项"
        },
        {
          value: "3",
          name: "商务加分项"
        }
      ],
      scoreProjectOrigins: [
        {
          value: "1",
          name: "商务"
        },
        {
          value: "3",
          name: "商务加分项"
        }
      ],
      scoreProject: [
        {
          value: "0",
          name: "技术"
        },
        {
          value: "1",
          name: "商务"
        },
        {
          value: "2",
          name: "技术加分项"
        },
        {
          value: "3",
          name: "商务加分项"
        }
      ],
      editScoreData: {
        tableData: [],
        packId: "",
        packName: "",
        scoreItem: "0",
        scoreItemStr: "技术",
        sumForm: "101",
        weight: 0,
        scoreTemplateId: ""
      },
      templateVisible: false,
      templateForm: {
        orgFullName: "",
        username: "",
        templateName: "",
        templateDesc: "",
        createTime: new Date()
      },
      templateTableData: [],
      packList: [], // 包件下拉框
      templateList: [], // 模板下拉框
      scoreItemSelectDisabled: false,
      subPackageFlag: "0",
      evaMethod: ""
    };
  },
  created() {
    if (this.operateType !== "add") {
      this.$set(this, "scoreItemSelectDisabled", true);
      this.editScoreData = JSON.parse(JSON.stringify(this.editScoreDataStr));
      this.editScoreData.tableData = this.editScoreData.sscScoreItemBOS
        ? this.editScoreData.sscScoreItemBOS
        : this.editScoreData.tableData
        ? this.editScoreData.tableData
        : [];
    }
    this.editScoreData.sumForm = "101"; //设置汇总形式默认显示
    this.evaMethod = JSON.parse(
      sessionStorage.getItem("bidEvaPrepareDetailData")
    ).evaMethod;
    if (this.evaMethod === "103") {
      this.scoreProject = JSON.parse(JSON.stringify(this.scoreProjectOrigins));
      if (this.operateType === "add") {
        this.editScoreData = {
          tableData: [],
          packId: "",
          packName: "",
          scoreItem: "1",
          scoreItemStr: "商务",
          sumForm: "101",
          weight: 0,
          scoreTemplateId: ""
        }; //设置汇总形式默认显示
      }
    }
    this.getData();
  },
  methods: {
    getData() {
      scpListPurchaseSchemePackageApi({
        pageNo: -1,
        pageSize: -1,
        schemeId: JSON.parse(sessionStorage.getItem("expertSourceData"))
          .schemeId
      }).then(res => {
        // 是否分包 1分包0不分包
        // subPackageFlag 是否分包 1分包0不分包
        this.subPackageFlag = res.data.data.subPackageFlag;
        // 新增 不分包的话判断是否添加了技术、技术加分项、商务、商务加分项，若都没有不进行才做，若添加了一个，换成另外一个
        if (this.operateType === "add") {
          if (res.data.data.subPackageFlag === "0") {
            if (this.scoredPack.length > 0) {
              this.scoreProject = JSON.parse(
                JSON.stringify(this.scoreProjectOrigin)
              );
              if (this.evaMethod === "103") {
                this.scoreProject = JSON.parse(
                  JSON.stringify(this.scoreProjectOrigins)
                );
              }
              for (let i = this.scoreProject.length - 1; i >= 0; i--) {
                let flag = this.scoredPack[0].sscScoreBOS.some(
                  item => item.scoreItem === this.scoreProject[i].value
                );
                if (flag) {
                  this.$delete(this.scoreProject, i);
                }
              }
              this.editScoreData.scoreItem = this.scoreProject[0].value;
              this.editScoreData.scoreItemStr = this.scoreProject[0].name;
              this.scoreItemSelectDisabled = true;
              // let len = this.scoredPack[0].sscScoreBOS.length;
              // switch (len) {
              //   case 0:
              //     break;
              //   case 1:
              //     if (this.scoredPack[0].sscScoreBOS[0].scoreItem === "0") {
              //       // 评审项目为技术
              //       this.$set(this.editScoreData, "scoreItem", "1");
              //       this.$set(this.editScoreData, "scoreItemStr", "商务");
              //     } else {
              //       this.$set(this.editScoreData, "scoreItem", "0");
              //       this.$set(this.editScoreData, "scoreItemStr", "技术");
              //     }
              //     this.scoreItemSelectDisabled = true;
              //     break;
              //   default:
              //     break;
              // }
            }
          }
        }
        // packStatus1正常2、5流标 不显示流标的包件
        let arr = res.data.data.purchaseSchemePackageList.filter(
          item => item.packStatus != "5" && item.packStatus != "2"
        );
        // 过滤技术、商务的评审项目都已经新增完毕的包件
        let allScore = [];
        this.scoredPack.forEach(item => {
          if (item.sscScoreBOS.length === 4) {
            allScore.push(item);
          }
        });
        this.packList = [...arr].filter(x =>
          [...allScore].every(y => y.packId !== x.packId)
        );
        console.log(this.packList, "this.packList..........");
      });
      scpQryScoreTemplateListApi({
        editUnitId: JSON.parse(localStorage.getItem("userInfo")).orgId,
        createId: JSON.parse(localStorage.getItem("userInfo")).openId
        // editUnitId: "",
        // createId: ""
      }).then(res => {
        this.templateList = res.data.data;
      });
    },
    // 改变包件
    changePack(value) {
      let _this = this;
      if (value) {
        let exsitFlag = false;
        _this.scoreProject = JSON.parse(
          JSON.stringify(_this.scoreProjectOrigin)
        );
        if (this.evaMethod === "103") {
          _this.scoreProject = JSON.parse(
            JSON.stringify(_this.scoreProjectOrigins)
          );
        }
        // 判断此包件的评审项目是否已经都添加技术、技术加分项、商务、商务加分项，若都没有评审项目不禁用，若添加了一个，评审项目自动赋值另外一个，并且禁用
        _this.scoredPack.forEach(item => {
          if (item.packId === value) {
            for (let i = _this.scoreProject.length - 1; i >= 0; i--) {
              let flag = item.sscScoreBOS.some(
                item => item.scoreItem === _this.scoreProject[i].value
              );
              if (flag) {
                _this.$delete(this.scoreProject, i);
              }
            }
            _this.editScoreData.scoreItem = _this.scoreProject[0].value;
            _this.editScoreData.scoreItemStr = _this.scoreProject[0].name;
            // let leng = item.sscScoreBOS.length;
            // switch (leng) {
            //   case 0:
            //     this.scoreItemSelectDisabled = false;
            //     break;
            //   case 1:
            //     if (item.sscScoreBOS[0].scoreItem === "0") {
            //       // 评审项目为技术
            //       this.$set(this.editScoreData, "scoreItem", "1");
            //       this.$set(this.editScoreData, "scoreItemStr", "商务");
            //     } else {
            //       this.$set(this.editScoreData, "scoreItem", "0");
            //       this.$set(this.editScoreData, "scoreItemStr", "技术");
            //     }
            //     exsitFlag = true;
            //     this.scoreItemSelectDisabled = true;
            //     break;
            //   default:
            //     this.scoreItemSelectDisabled = false;
            //     break;
            // }
          }
        });
        if (!exsitFlag) {
          this.scoreItemSelectDisabled = false;
        }
        // 赋值包件名称
        this.packList.forEach(item => {
          if (item.packId === value) {
            this.$set(this.editScoreData, "packId", item.packId);
            this.$set(this.editScoreData, "packName", item.packName);
          }
        });
      }
    },
    // 改变评审项目
    changeScoreItem(value) {
      if (value) {
        this.scoreProject.forEach(item => {
          if (item.value === value) {
            this.editScoreData.scoreItemStr = item.name;
          }
        });
      }
    },
    deleteRow(index) {
      // 删除行
      this.editScoreData.tableData.splice(index, 1);
      this.computeWeight();
    },
    addRow() {
      this.editScoreData.tableData.push({
        scoreWeight: 0
      });
      this.computeWeight();
    },
    // 计算权重
    computeWeight(value, index) {
      if (value) {
        if (Number(value) > 99999) {
          this.$set(this.editScoreData.tableData[index], "scoreWeight", 0);
        } else {
          this.$set(
            this.editScoreData.tableData[index],
            "scoreWeight",
            Number(value)
          );
        }
      }
      let weight = 0;
      this.editScoreData.tableData.forEach(item => {
        weight += Number(item.scoreWeight);
      });
      this.editScoreData.weight = weight;
    },
    // 改变模板选择
    changeScoreTemplate(value) {
      if (value) {
        scpQryScoreTemplateDetailApi({
          scoreTemplateId: value
        }).then(res => {
          this.editScoreData.tableData = [];
          this.editScoreData.tableData = Object.assign(
            [],
            res.data.data.sscScoreTemplateItemBOS
          );
          this.computeWeight();
        });
      }
    },
    // 新增模板
    addTemplate() {
      this.templateTableData = [];
      scpGetEmpInfoApi({
        openID: JSON.parse(localStorage.getItem("userInfo")).openId
      }).then(res => {
        if (res) {
          this.templateForm = {
            orgFullName: "",
            username: "",
            templateName: "",
            templateDesc: "",
            createTime: new Date()
          };
          this.$set(
            this.templateForm,
            "orgFullName",
            res.data.data.orgFullName
          );
          this.$set(this.templateForm, "username", res.data.data.name);
          this.templateVisible = true;
        }
      });
    },
    // 编辑模板
    editTemplate() {
      if (this.editScoreData.scoreTemplateId) {
        scpQryScoreTemplateDetailApi({
          scoreTemplateId: this.editScoreData.scoreTemplateId
        }).then(res => {
          this.templateForm = res.data.data;
          this.templateForm.scoreTemplateId = this.editScoreData.scoreTemplateId;
          this.templateTableData = res.data.data.sscScoreTemplateItemBOS;
          scpGetEmpInfoApi({
            openID: JSON.parse(localStorage.getItem("userInfo")).openId
          }).then(res => {
            if (res) {
              this.$set(
                this.templateForm,
                "orgFullName",
                res.data.data.orgFullName
              );
              this.$set(this.templateForm, "username", res.data.data.name);
              this.templateVisible = true;
            }
          });
        });
      } else {
        this.$message({
          message: "请选择需要编辑的模板",
          type: "warning",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    //删除模板
    deleteTemplate() {
      // 删除下拉框选中的模板
      if (this.editScoreData.scoreTemplateId) {
        scpDealScoreTemplateDeleteApi({
          scoreTemplateId: this.editScoreData.scoreTemplateId
        }).then(res => {
          if (res) {
            this.$message({
              message: "删除模板成功！！！",
              type: "success",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
            scpQryScoreTemplateListApi({
              editUnitId: "",
              createId: ""
            }).then(res => {
              this.templateList = res.data.data;
            });
            this.editScoreData.tableData = [];
            this.editScoreData.scoreTemplateId = "";
            scpQryScoreTemplateListApi({
              // editUnitId: JSON.parse(localStorage.getItem("userInfo")).orgId,
              editUnitId: "",
              createId: JSON.parse(localStorage.getItem("userInfo")).openId
            }).then(res => {
              this.templateList = res.data.data;
            });
            this.computeWeight();
          }
        });
      } else {
        this.$message({
          message: "请先选择要删除的模板！！",
          type: "error",
          duration: 3000,
          showClose: true,
          ccuiCustom: true
        });
      }
    },
    // 模板新增行
    addTemplateRow() {
      this.templateTableData.push({});
    },
    // 模板删除行
    deleteTemplateRow(index) {
      this.templateTableData.splice(index, 1);
    },
    // 模板新增或者编辑确定
    confirmEditTemplate() {
      let flag = true;
      this.templateTableData.forEach(item => {
        if (!item.scoreRule || !item.scoreWeight || !item.scoreStandard) {
          flag = false;
        }
      });
      this.$refs["templateForm"].validate(valid => {
        if (valid) {
          if (flag) {
            let param = {
              scoreTemplateId: this.templateForm.scoreTemplateId,
              templateName: this.templateForm.templateName,
              templateDesc: this.templateForm.templateDesc,
              createTime: this.templateForm.createTime,
              sscScoreTemplateItemBOS: this.templateTableData
            };
            scpDealScoreTemplateOperateApi(param).then(res => {
              if (res) {
                if (this.editScoreData.scoreTemplateId) {
                  scpQryScoreTemplateDetailApi({
                    scoreTemplateId: this.editScoreData.scoreTemplateId
                  }).then(res => {
                    this.editScoreData.tableData = Object.assign(
                      [],
                      res.data.data.sscScoreTemplateItemBOS
                    );
                  });
                  this.computeWeight();
                }
                scpQryScoreTemplateListApi({
                  // editUnitId: JSON.parse(localStorage.getItem("userInfo")).orgId,
                  editUnitId: "",
                  createId: JSON.parse(localStorage.getItem("userInfo")).openId
                }).then(res => {
                  this.templateList = res.data.data;
                });
                this.$message({
                  message: "模板编辑成功！！",
                  type: "success",
                  duration: 3000,
                  showClose: true,
                  ccuiCustom: true
                });
              }
            });
            this.templateVisible = false;
          } else {
            this.$message({
              message: "模板的内容不能为空！",
              type: "error",
              duration: 3000,
              showClose: true,
              ccuiCustom: true
            });
          }
        }
      });
    }
  }
};
</script>
<style lang="scss" scoped>
.star {
  color: #ff1818;
}
.el-form-item {
  margin-bottom: 15px !important;
}
.fr {
  float: right;
}
</style>
